<app-lms-modal-frame [title]="'Customer Notes'" [pageHeadWidth]="400">
  <div modal-body>
<form [formGroup]="clientNoteForm">
  <div class="card m-2">
    <div class="card-body p-1">
      <div fxFlex class="note-capture-holder" style="max-height: 700px">
        <div>
          <table class="container-fluid input-container px-1 d-flex align-content-end justify-content-end">
          <thead>
            <tr>
              <th *ngFor="let column of table_config.columns" [hidden]="column.hideCol">{{column.heading}}</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                <td>
                  <input formControlName="noteStr" placeholder="Client note" required>
                </td>
                <td>
                  <button [disabled]="savingNote" class="btn btn-primary btn-rounded mx-1" mdbRipple (click)="addClientNote()">
                    Add Note</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div fxLayout="row" class="ms-auto my-1 p-md-2 p-lg-3 p-1" fxLayoutAlign="start start" fxLayoutGap="10px">
          <table class="clientnote-list-wrapping table table-striped table-hover table-sm caption-top" style="max-height: 500px">
            <thead>
              <tr>
                <th *ngFor="let column of table_config.columns" [hidden]="column.hideCol">{{column.heading}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let table_row of clientNotes; let i = index;">
                <td *ngFor="let column of table_config.columns" [hidden]="column.hideCol">
                  <ng-container *ngIf="column.key === 'createdBy'">
                    <span class="text-emphasis text-start">
                      <div class="font-weight-bold"></div>{{table_row[column.key]}}</span><br>
                    <span class="ms-auto text-emphasis text-end">
                      <small class="ms-auto text-muted text-end">{{table_row['createdOn'] | date: 'yyyy-MM-dd HH:mm:ss'}}</small>
                    </span>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'noteStr'">
                    <div class="d-flex thisnote text-center note note-info">
                      <span class="list-note-item">
                        <div class="font-weight-bold">Note: </div>
                        {{table_row[column.key]}}
                      </span>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</form>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary btn-sm" (click)="closeDialog()">Close</button>
  </div>
</app-lms-modal-frame>
